import {
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Alert,
  AlertIcon,
  Box,
  Button,
  FormControl,
  FormLabel,
  Grid,
  GridItem,
  Input,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
} from '@chakra-ui/react';
import { usePemateriContext } from '../../../../controller/admin/data_master/pemateri';
import Select, { StylesConfig } from 'react-select';
import Loader from '../../../Loader';
import { useEffect } from 'react';

const ModalFormPemateri: React.FC = () => {
  const { setPemateriState, handleCheckNIP, handleSubmit, clearState } =
    usePemateriContext().dispatch;

  const {
    jenisPemateriSelected,
    isOpenModalPemateri,
    isLoadingNIP,
    dataAsn,
    isLoadingSubmit,
    isEdit,
    dataEdit,
    nip,
    nama,
    nik,
    tempat_lahir,
    tanggal_lahir,
    jabatan,
    instansi,
    errorMessage,
  } = usePemateriContext().state;

  const listJenisPemateri = [
    { label: 'ASN', value: 'ASN' },
    { label: 'NON ASN', value: 'NON_ASN' },
  ];

  const colourStyles: StylesConfig = {
    control: (styles, { isFocused }) => {
      return {
        ...styles,
        padding: '2px 8px',
      };
    },
    menu: (styles) => {
      return {
        ...styles,
        zIndex: 100,
      };
    },
  };

  useEffect(() => {
    if (isEdit && dataEdit) {
      setPemateriState('idUpdate', dataEdit.id);
      setPemateriState('nama', dataEdit.nama ?? '');
      setPemateriState('nik', dataEdit.nik ?? null);
      setPemateriState('tempat_lahir', dataEdit.tempat_lahir ?? '');
      setPemateriState('tanggal_lahir', dataEdit.tanggal_lahir ?? '');
      setPemateriState('jabatan', dataEdit.jabatan ?? '');
      setPemateriState('instansi', dataEdit.instansi ?? '');
      setPemateriState(
        'jenisPemateriSelected',
        listJenisPemateri.find((opt) => opt.value === dataEdit.jenis) ?? null
      );
      if (dataEdit.jenis === 'ASN' && dataEdit.nip) {
        setPemateriState('nip', dataEdit.nip);
        setPemateriState('dataAsn', {
          NAMA_LENGKAP: dataEdit.nama,
          nik: dataEdit.nik,
          TEMPAT_LAHIR: dataEdit.tempat_lahir,
          TANGGAL_LAHIR: dataEdit.tanggal_lahir,
        });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isEdit, dataEdit]);

  return (
    <>
      <Modal
        isOpen={isOpenModalPemateri}
        onClose={() => [
          clearState(),
          setPemateriState('isOpenModalPemateri', false),
        ]}
        size="3xl"
      >
        <ModalOverlay />
        <ModalContent>
          <ModalHeader fontSize="lg" fontWeight="bold">
            {isEdit ? 'Edit' : 'Tambah'} data master Pemateri
          </ModalHeader>
          <ModalCloseButton bgColor="red.400" color="white" />
          <ModalBody px={6}>
            <Grid templateColumns="repeat(8, 1fr)" gap={4} alignItems="center">
              <GridItem colSpan={2}>
                <Text fontWeight="semibold" fontSize="sm">
                  Jenis Pemateri
                </Text>
              </GridItem>
              <GridItem colSpan={6}>
                <Select
                  styles={colourStyles}
                  options={listJenisPemateri}
                  value={jenisPemateriSelected}
                  onChange={(e) => {
                    setPemateriState('jenisPemateriSelected', e);
                    // clear state
                    setPemateriState('nama', '');
                    setPemateriState('nik', null);
                    setPemateriState('nip', '');
                    setPemateriState('tempat_lahir', '');
                    setPemateriState('tanggal_lahir', '');
                    setPemateriState('jabatan', '');
                    setPemateriState('instansi', '');
                    setPemateriState('dataAsn', {});
                  }}
                  placeholder="Pilih Pemateri"
                />
              </GridItem>

              {jenisPemateriSelected?.value === 'ASN' ? (
                <>
                  {/* ASN */}
                  <GridItem colSpan={2}>
                    <FormControl isRequired>
                      <FormLabel fontWeight="semibold" fontSize="sm" isRequired>
                        NIP Pegawai
                      </FormLabel>
                    </FormControl>
                  </GridItem>
                  <GridItem colSpan={5}>
                    <Input
                      type="number"
                      placeholder="Masukkan NIP"
                      value={nip ? nip : ''}
                      onChange={(e) => setPemateriState('nip', e.target.value)}
                    />
                  </GridItem>
                  <GridItem colSpan={1}>
                    <Button
                      colorScheme="blue"
                      isLoading={isLoadingNIP}
                      isDisabled={isLoadingNIP}
                      onClick={() => handleCheckNIP()}
                    >
                      Cari NIP
                    </Button>
                  </GridItem>

                  {isLoadingNIP && (
                    <>
                      <GridItem colSpan={2}></GridItem>
                      <GridItem colSpan={6}>
                        <Loader />
                      </GridItem>
                    </>
                  )}
                  {!isLoadingNIP && Object.keys(dataAsn).length > 0 && (
                    <>
                      <GridItem colSpan={2}></GridItem>
                      <GridItem colSpan={6}>
                        <Box className="border" borderRadius="md" p="2">
                          <Accordion defaultIndex={[0]} allowMultiple>
                            <AccordionItem border="0">
                              <Text mb={2}>
                                <AccordionButton>
                                  <Box
                                    flex="1"
                                    textAlign="left"
                                    fontWeight="semibold"
                                    fontSize="lg"
                                  >
                                    Data ASN
                                  </Box>
                                  <AccordionIcon />
                                </AccordionButton>
                              </Text>
                              <AccordionPanel pb={4}>
                                <Grid
                                  templateColumns="repeat(8, 1fr)"
                                  gap={6}
                                  alignItems="center"
                                >
                                  <GridItem colSpan={2}>
                                    <Text fontWeight="semibold" fontSize="sm">
                                      Nama ASN
                                    </Text>
                                  </GridItem>
                                  <GridItem colSpan={6}>
                                    <Text>{dataAsn.NAMA_LENGKAP ?? '-'}</Text>
                                  </GridItem>
                                  {dataAsn.nik && (
                                    <>
                                      <GridItem colSpan={2}>
                                        <Text fontWeight="semibold" fontSize="sm">
                                          NIK
                                        </Text>
                                      </GridItem>
                                      <GridItem colSpan={6}>
                                        <Text>{dataAsn.nik}</Text>
                                      </GridItem>
                                    </>
                                  )}
                                  {dataAsn.TEMPAT_LAHIR && (
                                    <>
                                      <GridItem colSpan={2}>
                                        <Text fontWeight="semibold" fontSize="sm">
                                          Tempat Lahir
                                        </Text>
                                      </GridItem>
                                      <GridItem colSpan={6}>
                                        <Text>{dataAsn.TEMPAT_LAHIR}</Text>
                                      </GridItem>
                                    </>
                                  )}
                                  {dataAsn.TANGGAL_LAHIR && (
                                    <>
                                      <GridItem colSpan={2}>
                                        <Text fontWeight="semibold" fontSize="sm">
                                          Tanggal Lahir
                                        </Text>
                                      </GridItem>
                                      <GridItem colSpan={6}>
                                        <Text>{dataAsn.TANGGAL_LAHIR}</Text>
                                      </GridItem>
                                    </>
                                  )}
                                </Grid>
                              </AccordionPanel>
                            </AccordionItem>
                          </Accordion>
                        </Box>
                      </GridItem>
                    </>
                  )}

                  {!isLoadingNIP && errorMessage && (
                    <>
                      <GridItem colSpan={2} />
                      <GridItem colSpan={6}>
                        <Alert status="error" borderRadius="md">
                          <AlertIcon />
                          {errorMessage}
                        </Alert>
                      </GridItem>
                    </>
                  )}
                </>
              ) : jenisPemateriSelected?.value === 'NON_ASN' ? (
                <>
                  {/* NON ASN */}
                  <GridItem colSpan={2}>
                    <Text fontWeight="semibold" fontSize="sm">
                      Nama
                    </Text>
                  </GridItem>
                  <GridItem colSpan={6}>
                    <Input
                      type="text"
                      placeholder="Masukkan nama"
                      value={nama}
                      onChange={(e) => setPemateriState('nama', e.target.value)}
                    />
                  </GridItem>
                  <GridItem colSpan={2}>
                    <Text fontWeight="semibold" fontSize="sm">
                      NIK
                    </Text>
                  </GridItem>
                  <GridItem colSpan={6}>
                    <Input
                      type="number"
                      placeholder="Masukkan NIK"
                      value={nik ?? ''}
                      onChange={(e) => setPemateriState('nik', e.target.value)}
                    />
                  </GridItem>
                  <GridItem colSpan={2}>
                    <Text fontWeight="semibold" fontSize="sm">
                      Tempat Lahir
                    </Text>
                  </GridItem>
                  <GridItem colSpan={6}>
                    <Input
                      type="text"
                      placeholder="Masukkan tempat lahir"
                      value={tempat_lahir}
                      onChange={(e) =>
                        setPemateriState('tempat_lahir', e.target.value)
                      }
                    />
                  </GridItem>
                  <GridItem colSpan={2}>
                    <Text fontWeight="semibold" fontSize="sm">
                      Tanggal Lahir
                    </Text>
                  </GridItem>
                  <GridItem colSpan={6}>
                    <Input
                      type="date"
                      placeholder="Masukkan tanggal lahir"
                      value={tanggal_lahir}
                      onChange={(e) =>
                        setPemateriState('tanggal_lahir', e.target.value)
                      }
                    />
                  </GridItem>
                </>
              ) : null}

              <GridItem colSpan={2}>
                <Text fontWeight="semibold" fontSize="sm">
                  Jabatan
                </Text>
              </GridItem>
              <GridItem colSpan={6}>
                <Input
                  type="text"
                  placeholder="Masukkan jabatan"
                  value={jabatan}
                  onChange={(e) => setPemateriState('jabatan', e.target.value)}
                />
              </GridItem>
              <GridItem colSpan={2}>
                <Text fontWeight="semibold" fontSize="sm">
                  Instansi
                </Text>
              </GridItem>
              <GridItem colSpan={6}>
                <Input
                  type="text"
                  placeholder="Masukkan Instansi"
                  value={instansi}
                  onChange={(e) => setPemateriState('instansi', e.target.value)}
                />
              </GridItem>
            </Grid>
          </ModalBody>
          <ModalFooter>
            <Button
              colorScheme="gray"
              mr={3}
              onClick={() => [
                clearState(),
                setPemateriState('isOpenModalPemateri', false),
              ]}
            >
              Batal
            </Button>
            <Button
              colorScheme="green"
              isLoading={isLoadingSubmit}
              isDisabled={isLoadingSubmit}
              onClick={() => handleSubmit()}
            >
              Simpan
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
};
export default ModalFormPemateri;
